import { useEffect, useState } from "react";
import {
    Reactions,
    ReactionsFetcher,
    SpecificTypeReactionsFetcher,
} from "./ReactionsListModal.types";

const DEFAULT_LIMIT = 20;

export function useLoadItems(
    initialFetcher: ReactionsFetcher,
    mainFetcher: SpecificTypeReactionsFetcher,
    itemId: string,
    activeTab: number,
    limit = DEFAULT_LIMIT,
) {
    const [isInitDone, setIsInitDone] = useState(false);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState<Reactions[]>([]);
    const [hasNextPage, setHasNextPage] = useState<boolean>(true);
    const [error, setError] = useState<Error>();

    useEffect(() => {
        const fetchData = async () => {
            const reactions = await initialFetcher(itemId, limit);
            setItems(reactions);
            setIsInitDone(true);
        };
        fetchData();
    }, []);

    useEffect(() => {
        setHasNextPage(items[activeTab]?.hasMore);
    }, [activeTab, items]);

    async function loadMore() {
        const currentlyActiveTab = activeTab.valueOf();
        setError(undefined);
        setLoading(true);
        try {
            const currentActiveItem = items[currentlyActiveTab];
            const reactions = await mainFetcher(
                itemId,
                currentActiveItem.type,
                currentActiveItem.cursor,
                limit,
            );
            const updatedItem = {
                ...reactions,
                users: [...currentActiveItem.users, ...reactions.users],
                totalCount: currentActiveItem.totalCount,
            };
            setItems(
                items.map((item, index) =>
                    index === currentlyActiveTab ? { ...updatedItem } : item,
                ),
            );
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }
    const reset = () => {
        setIsInitDone(false);
        setItems([]);
        setError(undefined);
    };

    return {
        isInitDone,
        loading,
        items,
        hasNextPage,
        error,
        loadMore,
        reset,
    };
}
